import React, { useState, useEffect, useParams } from "react";
export const ReportContext = React.createContext();